export const ImgSliderItems = [
    {
        id:1,
        title:"Home",
        imgArr:[
            {
                id:12,
                imgSrc:"./images/28.jpeg"
            },
            {
                id:14,
                imgSrc:"./images/27.jpeg"
            },
            {
                id:13,
                imgSrc:"./images/26.jpeg"
            },
            {
                id:7,
                imgSrc:"./images/20.jpeg"
            },
            {
                id:8,
                imgSrc:"./images/21.jpeg"
            },
            {
                id:11,
                imgSrc:"./images/24.jpeg"
            },
           
         

        ]
    },
   
]

export const ImgSliderACat = [
    {
        id:2,
        title:"ACat",
        imgArr:[
            {
                id:1,
                imgSrc:"./logo192.png"
            },
            {
                id:2,
                imgSrc:"./logo512.png"
            },

        ]
    },
   
]